export function getFilers(experience) {

    // 1 - Novice
    // 2 - Intermédiaire
    // 3 - Expérimenté

    const displayETF = [false,false,false];
    const displayNoQuotes = [false,false,true];
    const displayBearish = [false,true,true];
    const minimumVolume = [150000,50000,null];
    const maximumVolume = [null,null,null];
    const minimumValue = [15,2,null];
    const maximumValue = [null,null,null];

    return {
        displayETF: displayETF[experience-1],
        displayNoQuotes: displayNoQuotes[experience-1],
        hideBearish: !displayBearish[experience-1],
        minimumVolume: minimumVolume[experience-1],
        maximumVolume: maximumVolume[experience-1],
        minimumValue: minimumValue[experience-1],
        maximumValue: maximumValue[experience-1],
    }
}

export function isFilterEnable(conf) {
    return !conf.displayETF ||
    !conf.displayNoQuotes ||
    conf.hideBearish ||
    conf.minimumVolume ||
    conf.maximumVolume ||
    conf.minimumValue ||
    conf.maximumValue;
}